import { SchemaFormFields } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import type { PortfolioAmount } from '@mews-commander/data-access';
import { PriceInput } from '../../../ConfigureProductForm/common/PriceInput';
import { fixedPriceAdjustmentUpsertSchema } from '../schemas';

interface FixedValueFieldProps {
    name: string;
    basePriceValue: PortfolioAmount;
    currencySymbol: string;
    localizedCurrency: string;
}

export const FixedValueField = ({ name, basePriceValue, currencySymbol, localizedCurrency }: FixedValueFieldProps) => (
    <SchemaFormFields
        namePrefix={name}
        schema={fixedPriceAdjustmentUpsertSchema}
        formDefinition={{
            fields: {
                value: {
                    label: lt('GeneralAdjustedPriceTaxExcl'),
                    render: (valueProps) => (
                        <PriceInput
                            {...valueProps}
                            defaultCurrencyCode={basePriceValue.currency}
                            prefix={currencySymbol}
                        />
                    ),
                    helper: (
                        <>
                            {lt('GeneralPriceExcludingTax')}
                            {UnicodeEntity.Colon}
                            {UnicodeEntity.Space}
                            {localizedCurrency}
                        </>
                    ),
                },
            },
            renderFields: (fields) => <>{fields.value}</>,
        }}
    />
);
